import axios from 'axios';
import API_BASE_URL from '../config';

// Ottieni il token dal localStorage (admin o user)
const getAuthToken = () => {
  const adminToken = localStorage.getItem('adminToken');
  const userToken = localStorage.getItem('token');
  return adminToken || userToken;
};

// Ottieni l'ID dell'utente corrente
const getUserId = () => {
  const userData = localStorage.getItem('user');
  if (userData) {
    try {
      const user = JSON.parse(userData);
      return user.id;
    } catch (e) {
      return null;
    }
  }
  return null;
};

// Invia un messaggio all'IA
export const sendAIMessage = async (message, conversationHistory = []) => {
  try {
    const token = getAuthToken();
    const userId = getUserId();
    
    const response = await axios.post(
      `${API_BASE_URL}/ai/chat`,
      {
        message,
        conversationHistory,
        userId // Aggiungi l'userId per il contesto del Becco
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Errore durante l\'invio del messaggio all\'IA:', error);
    throw error;
  }
};

// Invia un messaggio con risposta in streaming (per future implementazioni)
export const sendAIMessageStream = async (message, conversationHistory = [], onChunk) => {
  try {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/ai/chat/stream`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        message,
        conversationHistory
      })
    });

    if (!response.ok) {
      throw new Error('Errore nella risposta del server');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value);
      const lines = chunk.split('\n');

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const data = line.substring(6);
          if (data === '[DONE]') {
            return;
          }
          try {
            const parsed = JSON.parse(data);
            if (parsed.chunk && onChunk) {
              onChunk(parsed.chunk);
            }
            if (parsed.error) {
              throw new Error(parsed.error);
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        }
      }
    }
  } catch (error) {
    console.error('Errore durante lo streaming:', error);
    throw error;
  }
};
